import Loadable from 'react-loadable';

import Loader from '../../components/Loader';

const component = Loadable({
  loader: () => import('./index'),
  loading: Loader,
});

const loadData = () => (
  Promise.all([

  ])
);

export default {
  component,
  loadData,
};



// WEBPACK FOOTER //
// client/containers/PartnerBanners/Loadable.js